import * as React from "react";
import Spinner from '../../../common/components/spinner/spinner';
import Translate from '../../../common/functions/translate';
import AlertMessage from '../../../common/components/alertMessage/alertMessage';
import UserService from '../../../services/userService';
import AuthService from '../../../services/authService';
import { UserMedicineModel } from '../../../models/user/userMedicineModel';
//import { UserMedicineGridModel } from '../../../models/user/userMedicineGridModel';
import UserMedicinesList from './userMedicinesList';
import UserMedicineHistoryDialog from './userMedicineHistoryDialog';
import ConfirmDialog from '../../../common/components/confirmDialog/confirmDialog';
import MedicineSearchDialog from './medicineSearchDialog';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBell, faCheckCircle, faPills, faCalendarAlt, faPrescription, faChevronUp, faChevronDown } from '@fortawesome/free-solid-svg-icons';
import { connect } from 'react-redux';
import Fab from '@material-ui/core/Fab';
import AddIcon from '@material-ui/icons/Add';
import HistoryIcon from '@material-ui/icons/History';
import CSSTransition from 'react-transition-group/CSSTransition';
import Growl from '../../../common/components/alertMessage/growl';
import Badge from '@material-ui/core/Badge';
import * as HelperFunctions from "../../../common/functions/helperFunctions";
import { UserMedicineHistoryWrapperModel } from '../../../models/user/userMedicineHistoryWrapperModel';
import { UserMedicineHistoryModel } from '../../../models/user/userMedicineHistoryModel';
import UserMedicineHistoryAddEditDialog from './userMedicineHistoryAddEditDialog';
import UserNotificationListDialog from '../userNotification/userNotificationListDialog';
import { UserMedicineWithHistoryWrapper } from "../../../models/user/userMedicineWithHistoryWrapper";
import { UserMedicineSettingsModel } from '../../../models/user/userMedicineSettingsModel';
import Dialog from '@material-ui/core/Dialog';
import * as Modal from '../../../common/modalDialog';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import { faTimes, faFilter } from '@fortawesome/free-solid-svg-icons';
import { MuiPickersUtilsProvider, DatePicker } from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';
import Checkbox from '@material-ui/core/Checkbox';
import { MuiThemeProvider, createMuiTheme } from '@material-ui/core';
import * as Constants from '../../../common/constants';
import blue from '@material-ui/core/colors/blue';
import { DropdownModel } from "../../../models/dropdownModel";
import Select from '@material-ui/core/Select';
import FormControl from '@material-ui/core/FormControl';
import MenuItem from '@material-ui/core/MenuItem';
import InputLabel from '@material-ui/core/InputLabel';
import { TimePresetType } from "../../../common/enums";
import ExpandingList from '../../../common/components/expandingList/expandingList';
import { AuthorisationStatus } from '../../../common/enums';

export const smallDialogTheme = createMuiTheme({
  overrides: {
    MuiFormControl: {
      marginNormal: {
        marginTop: 5,
        marginBottom: 0,
        width: '90% !important'
      },
      root: {
        width: '100% !important'
      }
    },
    MuiDialog: {
      paper: {
        margin: 0,
        maxWidth: '350px !important',
        minWidth: '335px'
      }
    }
  },
  palette: {
    primary: blue
  },
});

interface IProps {
  history: any;
  userId: number;
  lang: string;
  location: any;
}

interface IState {
  isLoading: boolean;
  validationMessage: string;
  userId: number;
  currentUserMedicine: UserMedicineModel;
  userMedicines: Array<UserMedicineHistoryModel>
  isVisibleConfirmDialog: boolean;
  deleteValidationMessage: string;
  isVisibleSearchMedicineDialog: boolean;
  searchDialogError: any;
  expandedMedicine: Array<UserMedicineHistoryModel>;
  first: number;
  rows: number;
  totalRecords: number;
  activeUserMedicineCount: number;
  userName: string;
  selectedMedicineHistory: UserMedicineHistoryModel;
  isVisibleUserNotificationListDialog: boolean;
  isVisibleUserMedicineHistoryAddEditDialog: boolean;
  isAddHistory: boolean;
  medicineSettings: UserMedicineSettingsModel,
  isVisiblefilters: boolean;
  currentFilterSettings: UserMedicineSettingsModel
  filterByDates: boolean;
  timeDropdown: Array<DropdownModel>;
  selectedTime: number;
  canChooseDates: boolean;
  isMyFamily: boolean;
}

class UserMedicinesComponent extends React.Component<IProps, IState> {
  userService = new UserService();
  authService = new AuthService();
  growl: any;

  constructor(props: IProps) {
    super(props);

    this.state = {
      validationMessage: '',
      isLoading: false,
      userId: this.props.userId ? this.props.userId : 0,
      currentUserMedicine: new UserMedicineModel(),
      userMedicines: new Array<UserMedicineHistoryModel>(0),
      isVisibleConfirmDialog: false,
      deleteValidationMessage: '',
      isVisibleSearchMedicineDialog: false,
      searchDialogError: null,
      expandedMedicine: new Array<UserMedicineHistoryModel>(),
      first: 0,
      rows: 20,
      totalRecords: 0,
      activeUserMedicineCount: 0,
      userName: '',
      selectedMedicineHistory: new UserMedicineHistoryModel(),
      isVisibleUserNotificationListDialog: false,
      isVisibleUserMedicineHistoryAddEditDialog: false,
      isAddHistory: false,
      medicineSettings: new UserMedicineSettingsModel(),
      isVisiblefilters: false,
      currentFilterSettings: new UserMedicineSettingsModel(),
      filterByDates: false,
      timeDropdown: Array<DropdownModel>(0),
      selectedTime: 1,
      canChooseDates: false,
      isMyFamily: false
    };
  }

  componentDidMount() {
    window.addEventListener('scroll', this.onScroll);

    let tabName = HelperFunctions.getURLParameter('tabName');

    if (tabName && tabName == 'Family' && (this.props.history.action === "PUSH" || this.props.history.action === "POP")) {
      let userId = HelperFunctions.getURLParameter('userId');
      let userName = HelperFunctions.getURLParameter('userName');

      let numUser: number = userId ? parseInt(userId + '') : 0;
      this.setState({ userId: numUser, userName: userName + '', isMyFamily: true }, () => this.getAllUserMedicines(true));
    }
    else {
      this.setState({ userId: this.authService.getUserId(), userName: '', first: 0, isMyFamily: false }, () => this.getAllUserMedicines(true));
    }
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.onScroll);
  }


  componentDidUpdate(prevProps) {

    let tabName = HelperFunctions.getURLParameter('tabName');

    if (tabName && tabName == 'Family' && (this.props.history.action === "PUSH" || this.props.history.action === "POP") && !this.state.isMyFamily) {
      let userId = HelperFunctions.getURLParameter('userId');
      let userName = HelperFunctions.getURLParameter('userName');

      let numUser: number = userId ? parseInt(userId + '') : 0;
      this.setState({ userId: numUser, userName: userName + '', isMyFamily: true }, () => this.getAllUserMedicines(true));
    }
    if ((!tabName || tabName == '') && this.state.isMyFamily) {
      this.setState({ userId: this.authService.getUserId(), userName: '', first: 0, isMyFamily: false }, () => this.getAllUserMedicines(true));
    }

  }

  onScroll = () => {
    let scrollY = window.scrollY ? window.scrollY : window.pageYOffset;
    if (window.innerHeight + scrollY >= document.body.offsetHeight - 250 &&
      this.state.totalRecords > this.state.userMedicines.length && !this.state.isLoading) {
      this.paginatorClick({ first: this.state.first + this.state.rows }, false);
    }
  };

  paginatorClick = (e, isInit: boolean) => {
    this.setState({ first: e.first }, () => this.getAllUserMedicines(isInit));
  }

  getAllUserMedicines(isInit: boolean) {
    this.setState({
      isLoading: true
    });

    if (this.authService.isAuthenticated()) {
      let userId = this.state.userId ? this.state.userId : this.authService.getUserId();
      let settings: UserMedicineSettingsModel = new UserMedicineSettingsModel();
      if (this.state.currentFilterSettings) {
        if (this.state.filterByDates && this.state.currentFilterSettings.startDate) {
          settings.startDate = HelperFunctions.fomatDateTimeAsString(new Date(this.state.currentFilterSettings.startDate));
        }

        if (this.state.filterByDates && this.state.currentFilterSettings.endDate) {
          settings.endDate = HelperFunctions.fomatDateTimeAsString(new Date(this.state.currentFilterSettings.endDate));
        }

        if (this.state.currentFilterSettings.medicineName && this.state.currentFilterSettings.medicineName.trim() != '') {
          settings.medicineName = this.state.currentFilterSettings.medicineName;
        }
      }
      this.userService.getAllUserMedicinesWithHistory(userId, this.state.first, this.state.rows, this.props.lang, settings).then(
        (data: any) => {
          if (data) {
            if (isInit) {
              this.setState({
                isLoading: false,
                userMedicines: [...data.userMedicineHistory],
                totalRecords: data.totalRecords,
                activeUserMedicineCount: data.activeUserMedicineCount,
                userId: userId
              });
            }
            else {
              this.setState({
                isLoading: false,
                userMedicines: [...this.state.userMedicines, ...data.userMedicineHistory],
                totalRecords: data.totalRecords,
                userId: userId
              });
            }
          }
        })
        .catch(error => {
          this.growl.show({ severity: 'error', summary: error.message });
          this.setState({
            isLoading: false
          });
        });
    }
  }

  setCurrentUserMedicine(currentUserMedicine: UserMedicineModel) {
    this.setState({ currentUserMedicine: { ...currentUserMedicine } });
  }

  handleUserMedicineDeleteClick = (medHistory: UserMedicineHistoryModel) => {
    let message: string = Translate("Are you sure that you want to delete this record");
    if (medHistory.prescriptionDoctor && medHistory.prescriptionDoctor.trim() != '') {
      message = Translate("This medicine is attached to prescription") + ": " +
        medHistory.prescriptionDoctor + '. ' + Translate("Are you sure that you want to delete this record");
    }
    this.setState({
      isVisibleConfirmDialog: true,
      deleteValidationMessage: message,
      selectedMedicineHistory: medHistory
    });
  }

  deleteUserMedicine(medicineId: number, medhistoryId: number) {
    this.setState({
      isVisibleConfirmDialog: false,
      isLoading: true
    });

    this.userService.deleteUserMedicine(this.state.userId, medicineId, medhistoryId)
      .then(
        data => {
          this.growl.show({ severity: 'success', summary: Translate('Deleted Successfully') });
          this.setState({ first: 0, selectedMedicineHistory: new UserMedicineHistoryModel() }, () => this.getAllUserMedicines(true));
        },
        error => {
          this.growl.show({ severity: 'error', summary: Translate(error.message) });
          this.setState({
            isLoading: false
          });
        });
  }

  handleUserMedicineHistoryClick = (medicineId, userMedHistory: UserMedicineHistoryModel) => {
    this.setState({
      isLoading: true
    });
    let userId = this.state.userId ? this.state.userId : this.authService.getUserId();
    this.userService.getUserMedicine(userId, medicineId, this.props.lang)
      .then(
        (data: UserMedicineModel) => {
          this.setCurrentUserMedicine(data);
          this.setState({
            isLoading: false,
            isVisibleUserMedicineHistoryAddEditDialog: true,
            validationMessage: '',
            selectedMedicineHistory: userMedHistory,
            isAddHistory: false
          });
        },
        error => {
          this.growl.show({ severity: 'error', summary: Translate(error.message) });
          this.setState({
            isLoading: false
          });
        }
      );
  }

  handleUserMedicineInfoClick = (id) => {
    this.props.history.push(`${Constants.MedicinesUrl}/${id}`)
  }

  handleAddClick = () => {
    this.setState({
      isVisibleUserMedicineHistoryAddEditDialog: true,
      isAddHistory: true
    });
  }

  handleUserNotificationButtonClick = (userMedicineId) => {
    if (!userMedicineId) {
      this.growl.show({ severity: 'error', summary: "UserMedicine ID is not valid" });
    } else {
      let userMedicineHistory = this.state.userMedicines.find(d => d.userMedicineHistoryId === userMedicineId);
      if (userMedicineHistory) {
        this.setState({
          selectedMedicineHistory: userMedicineHistory
        }, () => this.showUserNotificationListDialog(true));
      } else {
        console.log("EROR")
      }
    }
  }

  showUserNotificationListDialog = (show: boolean) => {
    this.setState({
      isVisibleUserNotificationListDialog: show
    });
  }

  handleUserNotificationListDialogCloseButton = () => {
    this.setState({
      first: 0,
      isVisibleUserNotificationListDialog: false,
      selectedMedicineHistory: new UserMedicineHistoryModel()
    }, () => this.getAllUserMedicines(true));
  }

  handleHistoryAddButton = (currentUserMedicineHistory: UserMedicineHistoryModel, userMedicine: UserMedicineModel, close: boolean) => {
    this.setState({
      isLoading: true
    });

    let medWrapp: UserMedicineWithHistoryWrapper = new UserMedicineWithHistoryWrapper();
    medWrapp.userMedicine = userMedicine;
    medWrapp.userMedicineHistory = currentUserMedicineHistory;
    if (!medWrapp.userMedicine.userId || medWrapp.userMedicine.userId == 0) {
      medWrapp.userMedicine.userId = this.state.userId;
    }
    this.userService.addUserMedicine(medWrapp)
      .then(
        (data) => {
          this.growl.show({ severity: 'success', summary: Translate('Data Saved Successfully') });
          this.handleUserMedicineHistoryCancelClick();
          this.setState({ first: 0 }, () => this.getAllUserMedicines(true));
        },
        error => {
          this.growl.show({ severity: 'error', summary: Translate(error.message) });
          this.setState({
            isLoading: false
          });
        });
  }

  handleHistoryUpdateButton = (currentUserMedicineHistory: UserMedicineHistoryModel, close: boolean) => {
    this.setState({
      isLoading: true
    });

    this.userService.updateMedicineHistory(currentUserMedicineHistory)
      .then(
        (data) => {
          this.growl.show({ severity: 'success', summary: Translate('Data Saved Successfully') });
          this.setState({ first: 0 }, () => this.getAllUserMedicines(true));
          this.handleUserMedicineHistoryCancelClick();
        },
        error => {
          this.growl.show({ severity: 'error', summary: Translate(error.message) });
          this.setState({
            isLoading: false
          });
        });
  }

  expanedData = (rowData: UserMedicineHistoryModel) => {
    return (<div className="item-actions-panel">
      {/* <Fab size="small" color="secondary" aria-label="Add">
          <HistoryIcon />
        </Fab> */}

      <button
        type="button"
        className="item-actions-panel-buttons btn-info"
        style={{ backgroundColor: '#17a2b8', width: 50 }}
        onClick={() => this.handleUserMedicineInfoClick(rowData.medicineId ? rowData.medicineId : 0)}
      ><i style={{ verticalAlign: 'text-top' }} className="pi pi-info"></i></button>
      <button
        type="button"
        className="item-actions-panel-buttons btn-info"
        style={{ backgroundColor: '#17a2b8', width: 50 }}
        onClick={() => this.handleUserNotificationButtonClick(rowData.userMedicineHistoryId)}>
        <FontAwesomeIcon style={{ verticalAlign: 'text-top' }} icon={faBell}></FontAwesomeIcon>
      </button>
      <button
        type="button"
        className="item-actions-panel-buttons btn-warning"
        style={{ backgroundColor: '#ffba01', width: 50 }}
        onClick={() => this.handleUserMedicineHistoryClick(rowData.medicineId ? rowData.medicineId : 0, rowData)}
      > <i style={{ verticalAlign: 'text-top' }} className="pi pi-pencil"></i></button>
      <button
        type="button"
        className="item-actions-panel-buttons btn-danger"
        style={{ backgroundColor: '#e91224', width: 50 }}
        onClick={() => this.handleUserMedicineDeleteClick(rowData)}
      ><i style={{ verticalAlign: 'text-top' }} className="pi pi-trash"></i></button>
    </div>)
  }

  rowExpansionTemplate = (rowData: UserMedicineHistoryModel) => {
    return (
      <CSSTransition in={this.state.expandedMedicine.some(r => r.userMedicineHistoryId == rowData.userMedicineHistoryId)}
        timeout={300} classNames="list-slide" mountOnEnter unmountOnExit>
        {this.expanedData(rowData)}
      </CSSTransition>
    );
  }

  expandData = (data: UserMedicineHistoryModel) => {
    if (!this.state.expandedMedicine.some(r => r.userMedicineHistoryId == data.userMedicineHistoryId) ||
      this.state.expandedMedicine.length == 0) {
      this.setState({ expandedMedicine: [...this.state.expandedMedicine, data] });
    } else {
      this.setState({ expandedMedicine: this.state.expandedMedicine.filter(r => r.userMedicineHistoryId != data.userMedicineHistoryId) });
    }
  }

  handleUserMedicineHistoryCancelClick = () => {
    this.setState({
      isVisibleUserMedicineHistoryAddEditDialog: false,
      selectedMedicineHistory: new UserMedicineHistoryModel()
    });
  }

  handleFilterChange = (key, value) => {
    const userFilter: UserMedicineSettingsModel = { ...this.state.medicineSettings };
    userFilter[key] = value;
    this.setState({ medicineSettings: { ...userFilter }, first: 0 })
  };

  clearFilters = (e) => {
    if (e) {
      e.preventDefault();
    }
    this.setState({
      isVisiblefilters: false, currentFilterSettings: new UserMedicineSettingsModel(),
      medicineSettings: new UserMedicineSettingsModel(), selectedTime: 1, filterByDates: false
    }, () => this.getAllUserMedicines(true));
  }

  handleFilter = (e) => {
    e.preventDefault();
    let filters = { ...this.state.medicineSettings };
    if (!filters.startDate) {
      filters.startDate = HelperFunctions.getDaysEarlier(new Date().toString(), 1).toISOString();
    }
    if (!filters.endDate) {
      filters.endDate = new Date().toISOString();
    }
    this.setState({ isVisiblefilters: false, currentFilterSettings: filters, filterByDates: true }, () => this.getAllUserMedicines(true));
  }

  getMonthEarlier = (currentDate: string) => {
    let d = new Date(currentDate);
    d.setMonth(d.getMonth() - 1);
    return d;
  }

  filterClick = () => {
    let currentSettings: UserMedicineSettingsModel = new UserMedicineSettingsModel();
    let startDate: boolean = false;
    let endDate: boolean = false;
    if (this.state.currentFilterSettings &&
      (this.state.currentFilterSettings.endDate || this.state.currentFilterSettings.startDate || this.state.currentFilterSettings.medicineName)) {
      currentSettings = { ...this.state.currentFilterSettings };
    }

    let timeDr = new Array<DropdownModel>(0);
    timeDr = HelperFunctions.enumToDropdownArray(TimePresetType, true);

    this.setState({ isVisiblefilters: true, medicineSettings: { ...currentSettings }, timeDropdown: timeDr });
  }

  getFiltersummary = () => {
    let nameSet: any = null;
    let startSet: any = null;
    let endSet: any = null;

    if (this.state.currentFilterSettings && this.state.currentFilterSettings.medicineName) {
      nameSet =
        <>
          <span style={{ color: '#999' }}>{Translate('Medicine')}</span>:
        <span style={{ fontWeight: 600 }}> {this.state.currentFilterSettings.medicineName} </span>
        </>
    }

    if (this.state.currentFilterSettings && this.state.currentFilterSettings.startDate) {
      startSet =
        <>
          <span style={{ color: '#999' }}>{Translate('From')}</span>:
        <span style={{ fontWeight: 600 }}> {HelperFunctions.fomatDateAsStringWithLang(new Date(this.state.currentFilterSettings.startDate), this.props.lang)} </span>
        </>
    }

    if (this.state.currentFilterSettings && this.state.currentFilterSettings.endDate) {
      endSet =
        <>
          <span style={{ color: '#999' }}>{Translate('To')}</span>:
        <span style={{ fontWeight: 600 }}> {HelperFunctions.fomatDateAsStringWithLang(new Date(this.state.currentFilterSettings.endDate), this.props.lang)} </span>
        </>
    }

    let summary =
      <p style={{ marginTop: 0 }}>
        {nameSet}
        {startSet}
        {endSet}
      </p>

    return summary;
  }

  handleTimeDropdownChange = (id) => {
    let filters = { ...this.state.medicineSettings };
    let canChooseDates = false;
    switch (id) {
      case TimePresetType.OneDay:
        filters.startDate = HelperFunctions.getDaysEarlier(new Date().toString(), 1).toISOString();
        filters.endDate = new Date().toISOString();
        canChooseDates = false;
        break;
      case TimePresetType.OneWeek:
        filters.startDate = HelperFunctions.getDaysEarlier(new Date().toString(), 7).toISOString();
        filters.endDate = new Date().toISOString();
        canChooseDates = false;
        break;
      case TimePresetType.OneMonth:
        filters.startDate = HelperFunctions.getMonthsEarlier(new Date().toString(), 1).toISOString();
        filters.endDate = new Date().toISOString();
        canChooseDates = false;
        break;
      case TimePresetType.ThreeMonths:
        filters.startDate = HelperFunctions.getMonthsEarlier(new Date().toString(), 3).toISOString();
        filters.endDate = new Date().toISOString();
        canChooseDates = false;
        break;
      case TimePresetType.SixMonths:
        filters.startDate = HelperFunctions.getMonthsEarlier(new Date().toString(), 6).toISOString();
        filters.endDate = new Date().toISOString();
        canChooseDates = false;
        break;
      case TimePresetType.OneYear:
        filters.startDate = HelperFunctions.getMonthsEarlier(new Date().toString(), 12).toISOString();
        filters.endDate = new Date().toISOString();
        canChooseDates = false;
        break;
      case TimePresetType.Advanced:
        canChooseDates = true;
    }
    this.setState({ selectedTime: id, medicineSettings: filters, canChooseDates: canChooseDates });
  }

  goToPrescriptions = (e, perscriptionId) => {
    e.preventDefault();
    this.props.history.push(`${Constants.PrescriptionUrl}?perscriptionId=${perscriptionId}`);
  }

  keyItem = (item: UserMedicineHistoryModel) => {
    return item.userMedicineHistoryId + "medId";
  }

  itemName = (item: UserMedicineHistoryModel) => {
    let today = HelperFunctions.fomatDateAsString(new Date());
    return (
      <>
        {new Date(item.startDate ? item.startDate.substr(0, 10) : '') <= new Date(today) && new Date(item.endDate ? item.endDate.substr(0, 10) : '') >= new Date(today) ?
          <FontAwesomeIcon icon={faCheckCircle} className="item-info-icon" style={{ color: '#fb512d' }} /> : null}
        {item.medicineName ? item.medicineName : null}
        {item.authorisationStatus > 0 && item.authorisationStatus != AuthorisationStatus.Authorised ?
          <span style={{ color: '#ff0000' }}> - {HelperFunctions.getEnumLabel(item.authorisationStatus, AuthorisationStatus, true)}</span> : null}
      </>)
  }

  itemDesc = (item: UserMedicineHistoryModel) => {
    return (
      <>
        <div className="item-desc-info">
          <FontAwesomeIcon style={{ width: '24px' }} icon={faCalendarAlt} />
          {HelperFunctions.fomatDatesStringWithLang(new Date(item.startDate ? item.startDate : ''), this.props.lang) + " - "}
          {HelperFunctions.fomatDatesStringWithLang(new Date(item.endDate ? item.endDate : ''), this.props.lang)}
        </div>
        <div className="item-desc-info">
          <FontAwesomeIcon style={{ width: '24px' }} icon={faBell} />
          {Translate('Alarms')}
          <div className="badge text-badge">
            {item.notificationsCount ? item.notificationsCount : '0'}
          </div>
        </div>
        {item.prescriptionDoctor && item.prescriptionDoctor.trim() != '' ?
          <div className="item-desc-info">
            <FontAwesomeIcon style={{ width: '24px' }} icon={faPrescription} />
            <a href="" onClick={(e) => this.goToPrescriptions(e, item.prescriptionId)}>
              {Translate('Doctors prescription from doctor') + ": " + item.prescriptionDoctor}
            </a>
          </div> : null}
      </>
    )
  }

  itemActions = (item: UserMedicineHistoryModel) => {
    return (
      <>
        {window.innerWidth >= Constants.device.tablet ? this.expanedData(item) :

          this.state.expandedMedicine.some(r => r.userMedicineHistoryId == item.userMedicineHistoryId) ?
            <FontAwesomeIcon icon={faChevronUp} />
            : <FontAwesomeIcon icon={faChevronDown} />
        }
      </>
    )
  }

  public render() {
    const { isLoading, userMedicines, totalRecords, activeUserMedicineCount, currentFilterSettings, selectedMedicineHistory, isVisibleSearchMedicineDialog,
      searchDialogError, expandedMedicine, timeDropdown, selectedTime, medicineSettings } = this.state;

    let userName = HelperFunctions.getURLParameter('userName');
    let showAllLink = false;
    if ((currentFilterSettings.medicineName && currentFilterSettings.medicineName.trim() != '') || currentFilterSettings.startDate || currentFilterSettings.endDate) {
      showAllLink = true
    }
    return (
      <div className="app-content">
        <Growl ref={(el) => this.growl = el} />

        <>
          {userName ?
            <>
              <div><FontAwesomeIcon icon={faPills} style={{ color: '#999' }}></FontAwesomeIcon> {Translate('Medicines of')}: </div>
              <h3>{userName} </h3>
            </>
            : <h2>{Translate('My Medicines')}</h2>}
          <Fab color="primary" aria-label="Add" size="small" onClick={() => this.handleAddClick()} className="floating-action-button">
            <AddIcon />
          </Fab>
          <Fab color="primary" focusRipple={false} aria-label="Search" size="small" onClick={() => this.filterClick()} className="floating-action-button-second">
            <FontAwesomeIcon icon={faFilter} />
          </Fab>

          {!isLoading && userMedicines && userMedicines.length > 0 ?
            <div className="list-items-count-info">
              <span className='list-items-count-info-number'>{totalRecords}</span> {Translate('total records.')}<br />
              <span className='list-items-count-info-number'>{activeUserMedicineCount}</span> {Translate('current medicine history.')}
              {activeUserMedicineCount > 0 ?
                <span> <FontAwesomeIcon icon={faCheckCircle} className="item-info-icon" style={{ color: '#fb512d' }} /></span>
                : null}
            </div> : null}

          {currentFilterSettings && (currentFilterSettings.medicineName || currentFilterSettings.startDate || currentFilterSettings.endDate) ?
            <>
              <p style={{ marginBottom: 0, fontWeight: 600 }}>{Translate('Filters') + ":"}</p>
              {this.getFiltersummary()}
            </>
            : null}

          {showAllLink ?
            <div style={{ margin: '10px 0' }}>
              <a href='' onClick={(e) => this.clearFilters(e)}>{Translate('See All')}</a>
            </div> : null}


          <ExpandingList
            listItems={userMedicines}
            keyItem={this.keyItem}
            expandData={this.expandData}
            expandedPanel={this.rowExpansionTemplate}
            itemName={this.itemName}
            itemDesc={this.itemDesc}
            itemActions={this.itemActions}
            isExpandable={window.innerWidth < Constants.device.tablet}
            infoStyle={window.innerWidth < Constants.device.tablet ? {} : { width: 'unset' }}
          />


          {/* <UserMedicinesList
            userMedicines={userMedicines}
            expandData={this.expandData}
            rowExpansionTemplate={this.rowExpansionTemplate}
            expandedMedicines={expandedMedicine}
            lang={this.props.lang}
            goToPrescriptions={this.goToPrescriptions}
          /> */}
          {isLoading ? <Spinner inlineSpinner={true} /> : null}
          {!isLoading && (!userMedicines || userMedicines.length == 0) ? Translate("No records found") : null}
        </>

        <ConfirmDialog
          headerTitle={Translate("Confirm Dialog")}
          isVisible={this.state.isVisibleConfirmDialog}
          yesClick={() => { this.deleteUserMedicine(selectedMedicineHistory.medicineId, selectedMedicineHistory.userMedicineHistoryId) }}
          noClick={() => { this.setState({ isVisibleConfirmDialog: false, deleteValidationMessage: '', selectedMedicineHistory: new UserMedicineHistoryModel() }) }}>
          {this.state.deleteValidationMessage}
          {/* Are you sure that you want to delete&nbsp;
          {currentUserMedicine.medicine
            ? [currentUserMedicine.medicine.brandName, currentUserMedicine.medicine.additionalTitle].filter(Boolean).join(' / ')
            : "this record"}? */}
        </ConfirmDialog>

        {this.state.isVisibleUserNotificationListDialog ? (
          <UserNotificationListDialog
            userMedicineHistoryId={selectedMedicineHistory.userMedicineHistoryId}
            isVisible={this.state.isVisibleUserNotificationListDialog}
            closeClick={this.handleUserNotificationListDialogCloseButton}
            lang={this.props.lang}
          />) : null}

        {this.state.isVisibleUserMedicineHistoryAddEditDialog ? (
          <UserMedicineHistoryAddEditDialog
            currentUserMedicineHistory={selectedMedicineHistory}
            addClick={this.handleHistoryAddButton}
            cancelClick={this.handleUserMedicineHistoryCancelClick}
            isVisible={this.state.isVisibleUserMedicineHistoryAddEditDialog}
            updateClick={this.handleHistoryUpdateButton}
            lang={this.props.lang}
            userId={this.props.userId}
            isAdd={this.state.isAddHistory}
          />
        ) : null}

        <Dialog
          open={this.state.isVisiblefilters}
          onClose={() => this.setState({ isVisiblefilters: false })}
          fullWidth={window.innerWidth < Constants.device.desktop}
          aria-labelledby="responsive-dialog-title"
        >
          <Modal.DialogTitle id="customized-dialog-title" onClose={() => this.setState({ isVisiblefilters: false })}>{Translate('Filters')}</Modal.DialogTitle>
          <Modal.DialogContent>
            <div style={{ minHeight: 200, minWidth: window.innerWidth < Constants.device.desktop ? 'unset' : 400 }}>
              <div className="p-col-12 p-md-12 pl-0 pb-15" >
                <div>
                  <TextField
                    autoComplete="off"
                    id="standard-name"
                    label={Translate('Medicine')}
                    value={medicineSettings && medicineSettings.medicineName ? medicineSettings.medicineName : ""}
                    onChange={(e) => this.handleFilterChange('medicineName', e.target['value'])}
                    margin="none"
                  />
                </div>
              </div>

              <div style={{ marginBottom: 15 }}>
                <FormControl>
                  <InputLabel htmlFor="preset-type-label">{Translate('Period')}</InputLabel>
                  <Select
                    value={selectedTime}
                    onChange={(e) => this.handleTimeDropdownChange(e.target.value)}
                    inputProps={{
                      id: 'preset-type-label'
                    }}>
                    {timeDropdown.map(m => <MenuItem key={m.value + 'timeItem'}
                      value={m.value}>{m.value ? m.label : <em>{m.label}</em>}</MenuItem>)}
                  </Select>
                </FormControl>
              </div>
              {this.state.canChooseDates ?
                <>
                  <div style={{ marginBottom: 15 }}>
                    <label style={{ width: '100%' }}>{Translate('From')}:</label>
                    <MuiPickersUtilsProvider utils={DateFnsUtils}>
                      <DatePicker
                        format={Translate('DateFormat')}
                        margin="normal"
                        value={medicineSettings.startDate ? new Date(medicineSettings.startDate) : HelperFunctions.getDaysEarlier(new Date().toString(), 1)}
                        onChange={(e) => this.handleFilterChange('startDate', e)}
                      />
                    </MuiPickersUtilsProvider>
                  </div>
                  <div>
                    <label style={{ width: '100%' }}>{Translate('To')}:</label>
                    <MuiPickersUtilsProvider utils={DateFnsUtils}>
                      <DatePicker
                        format={Translate('DateFormat')}
                        margin="normal"
                        value={medicineSettings.endDate ? new Date(medicineSettings.endDate) : new Date()}
                        onChange={(e) => this.handleFilterChange('endDate', e)}
                      />
                    </MuiPickersUtilsProvider>
                  </div>
                </> :
                <>
                  <div style={{ marginBottom: 15, display: 'flex', alignItems: 'flex-end' }}>
                    <label style={{ width: 'unset', marginRight: 10 }}>{Translate('From')}:</label>
                    <div style={{ fontSize: 15 }}>
                      {HelperFunctions.fomatDateAsStringWithLang(medicineSettings.startDate ?
                        new Date(medicineSettings.startDate) : HelperFunctions.getDaysEarlier(new Date().toString(), 1), this.props.lang)}
                    </div>
                  </div>
                  <div style={{ display: 'flex', alignItems: 'flex-end' }}>
                    <label style={{ width: 'unset', marginRight: 10 }}>{Translate('To')}:</label>
                    <div style={{ fontSize: 15 }}>
                      {HelperFunctions.fomatDateAsStringWithLang(medicineSettings.endDate ?
                        new Date(medicineSettings.endDate) : new Date(), this.props.lang)}
                    </div>
                  </div>
                </>
              }
            </div>

          </Modal.DialogContent>
          <Modal.DialogActions>
            <div style={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}>
              <div>
                <Button variant="contained" size="small" color="secondary"
                  onClick={this.clearFilters}>
                  <FontAwesomeIcon icon={faTimes} style={{ marginRight: '5px' }} />
                  {Translate('Clear')}
                </Button>
              </div>
              <div>
                <Button variant="contained" size="small" onClick={() => this.setState({ isVisiblefilters: false })} style={{ marginRight: '5px' }}>
                  <FontAwesomeIcon icon={faTimes} style={{ marginRight: '5px' }} />
                  {Translate('Cancel')}
                </Button>
                <Button variant="contained" size="small" color="primary" onClick={(e) => this.handleFilter(e)}>
                  <FontAwesomeIcon icon={faFilter} style={{ marginRight: '5px' }} />
                  {Translate('Filtering')}
                </Button>
              </div>
            </div>
          </Modal.DialogActions>
        </Dialog>
      </div>
    )
  }
}

const mapsStateToProps = state => {
  return {
    lang: state.common.lang
  };
}

export default connect(mapsStateToProps)(UserMedicinesComponent);